var enLang = {
	"Kết thúc sau": "End in",
	"ngày": "day",
	"Còn {{DurationDays}} ngày": "{{DurationDays}} days left",
	"Giảm trực tiếp": "Discount",
	"Tặng": "Receive",
	"GIẢM": "Decrease",
	"Không tìm thấy sản phẩm nào": "No product found",
	"Cảnh báo": "Warning",
	"src.components.ProductCard.ProductCard.0": "This is alcohol product, please confirm you are 18 years old to purchase!",
	"Tôi trên 18 tuổi": "I am over 18",
	"Tôi dưới 18 tuổi": "I am under 18",
	"Xác nhận": "Confirm",
	"TIẾT KIỆM": "Save",
	"Xem thêm": "Expand",
	"Thu gọn": "Collapse",
	"Bộ lọc đã dùng": "Used filter",
	"Xóa bộ lọc": "Clear filter",
	"Hàng trưng bày": "Sample",
	"Hàng đặt trước": "Pre-order",
	"Ngừng kinh doanh": "Stop selling",
	"Hàng quà tặng": "Gift",
	"Còn lại {{var0}}": "{{var0}} left",
	"Đã bán {{FlSaleUsedCount}}": "{{FlSaleUsedCount}} sold",
	"Hàng sắp về": "Coming soon",
	"Liên hệ": "Contact",
	"Còn {{stockQuantity}} sản phẩm": "{{stockQuantity}} left",
	"Xem tất cả": "View all",
	"Thương hiệu nổi bật": "Featured brands",
	"Danh mục sản phẩm": "Categories",
	"Sản phẩm dành cho bạn": "Products for you",
	"Chọn ngày nhận hàng": "Select delivery date",
	"Chọn khung giờ": "Select delivery time",
	"Tìm kiếm gần đây": "Recent search",
	"Chọn khu vực nhận hàng": "Select the location",
	"Vui lòng chọn khu vực nhận hàng của bạn": "Please select your location",
	"Tìm kiếm Tỉnh/ Thành phố": "Search Province/City",
	"Không tìm thấy tỉnh thành phố nào !!": "No provice/city is found !!",
	"Khi thay đổi thông tin đơn hàng thanh toán lại, đơn hiện tại sẽ bị hủy. Giá và khuyến mại đơn hàng có thể bị thay đổi. Bạn có chắc chắn muốn thực hiện thao tác này?": "When changing payment order information, current order will be canceled. Order prices and promotions are subject to change. Are you sure you want to perform this action?",
	"Trường hợp muốn thay đổi hình thức thanh toán hoặc các thông tin khác, vui lòng": "If you want to change your payment configuration or other information, please",
	"Bấm vào đây": "Click here",
	"Xem chi tiết": "View detail",
	"Cần thanh toán": "Need to pay",
	"Giao hàng bởi": "Delivered by",
	"Mã vận đơn": "Shipment code",
	"Cung cấp bởi": "Provided by",
	"Combo giảm ~": "Combo discount ~",
	"Hết hàng": "Out of stock",
	"Ghi chú": "Note",
	"Khuyến mãi áp dụng": "Promotion applied"
};

export { enLang as default };
